import { Component, OnInit } from '@angular/core';
import { ClipboardService } from 'ngx-clipboard';
import { MetaService } from '../meta.service';
import { ProfilesService } from '../profiles.service';
import { ToastService } from '../toasts.service';

@Component({
  selector: 'app-profiles',
  templateUrl: './profiles.component.html',
  styleUrls: ['./profiles.component.css']
})
export class ProfilesComponent implements OnInit {

//declare variables
profiles: any[] = [];
filtered: any[] = [];
strSearch: string = '';
strView: string = 'list';
selected: any = null;

//inject services
constructor(private profs: ProfilesService, private mds: MetaService, private clipboardApi: ClipboardService, private tst: ToastService) { }

//initialize the component
ngOnInit(): void {
  //get the regulations
  this.profiles = this.profs.getList();
  //filter them
  this.sort(this.profiles);

  //SEO Optimization
  var strTitle = 'RegScale - Profiles';
  var description = 'RegScale list of supported profiles';
  var keywords = 'RegScale, profiles, baselines, templates, overlays';
  this.mds.updateTags(strTitle, keywords, description);
}

//filters catalogs based on user search criteria
filter() {
  var search = this.strSearch.toLowerCase();
  if (this.strSearch == '') {
    //reset to all records
    this.sort(this.profiles);
  } else {
    var filteredArray = this.profiles.filter(t => t.name.toLowerCase().indexOf(search) > -1 || t.lookup.toLowerCase().indexOf(search) > -1);
    this.sort(filteredArray);
  }
}

//sort the array
sort(array: any[]) {
  this.filtered = array.sort(function (a, b) {
    var firstValue = a.lookup.toLowerCase();
    var secondValue = b.lookup.toLowerCase();
    if (firstValue < secondValue) {
      return -1;
    } else {
      return 1;
    }
  });
}

//loads the provided regulation
load(reg) {
  this.strView = 'download';
  this.selected = reg;
  this.selected.powershell = 'Invoke-WebRequest -Uri "' + reg.link + '" -OutFile "' + reg.lookup + '.json"';
  this.selected.curl = 'curl ' + reg.link + ' --output ' + reg.name;
}

//copy the token to the clipboard
copy(strCopy) {
  this.clipboardApi.copyFromContent(strCopy);
  this.tst.show('Download command copied to the clipboard.', 'Success', 'fas fa-copy', { classname: 'bg-success text-white text-center toaster', delay: 5000 });
}

//back to list
back() {
  this.strView = 'list';
  this.selected = null;
}

}
